module.exports = __webpack_public_path__ + "img/percent.0c3fb0fb.svg";